import classNames from 'classnames';
import { useTrackedValue } from 'hooks/useTrackedValue';
import { useTrend } from 'hooks/useTrend';
import React, { ReactNode } from 'react';

export type TickingValueProps = { children: ReactNode; value?: number };
export function TickingValue({ children, value }: TickingValueProps): React.JSX.Element {
  const trackedValue = useTrackedValue(value);
  const trendClassName = useTrend(trackedValue);

  return <span className={classNames('tabular-figures ', trendClassName)}>{children}</span>;
}
